/**
 * Master switch for the review_agent sidecar (persona scorecards / verdicts).
 *
 * Off = the add-in makes no calls to the sidecar (port 8001): the persona
 * ReviewPanel, the Coverage tab, and the spine verdict watcher are not mounted,
 * so none of their polling hooks (useReviewAgent / useReviewProgress /
 * useRunVerdictWatcher) ever start. The container and its endpoints are left
 * intact — flip this to `true` to fully restore the feature.
 *
 * See plan note 2026-06-20 (review_agent 404 spam).
 */
export const REVIEW_AGENT_ENABLED = false;
